module.exports = __webpack_public_path__ + "static/media/go-6.30bd42ea.svg";